import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ScullyRoutesService} from "@scullyio/ng-lib";
import {take} from 'rxjs/operators';
import {Title} from "@angular/platform-browser";

declare var window: any;

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
  preserveWhitespaces: true,
  encapsulation: ViewEncapsulation.Emulated,
})
export class MediaComponent implements OnInit {
  public media$

  constructor(private srs: ScullyRoutesService, private titleService: Title) {
  }

  async ngOnInit() {
    this.media$ = await this.srs.getCurrent().pipe(take(1)).toPromise()
    this.titleService.setTitle(this.media$.title + " | MatchMove")
  }
}
